import { IBarcodeStyle } from "./IBarcodeStyle";
import { BarcodeKinds } from "./BarcodeKinds";
import { IQrCodeStyle } from "./IQrCodeStyle";

export class QrCodeStyle {
  constructor(
    public cellSize: number,
    public version: number
  ) {
  }

  clone(): QrCodeStyle {
    return new QrCodeStyle(this.cellSize, this.version);
  }

  static from(source: IQrCodeStyle): QrCodeStyle {
    return new QrCodeStyle(source.cellSize, source.version);
  }

  static to(source: QrCodeStyle): IQrCodeStyle {
    return {
      cellSize: source.cellSize,
      version: source.version,
    };
  }
}

export class BarcodeStyle {
  constructor(
    public kind: BarcodeKinds,
    public separator: string,
    public qrCode: QrCodeStyle
  ) {
  }
  
  clone(): BarcodeStyle {
    return new BarcodeStyle(this.kind, this.separator, this.qrCode);
  }

  static from(source: IBarcodeStyle): BarcodeStyle {
    return new BarcodeStyle(source.kind, source.separator, QrCodeStyle.from(source.qrCode));
  }

  static to(source: BarcodeStyle): IBarcodeStyle {
    return {
      kind: source.kind,
      separator: source.separator,
      qrCode: source.qrCode.clone(),
    };
  }
}
